<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Modifier la célébrité</h5>
        <button type="button" class="btn-close" (click)="modalServices.dismiss()"></button>
    </div>

    <!-- Loader centré -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center p-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Chargement...</span>
        </div>
    </div>

    <!-- Formulaire -->
    <div class="modal-body" [class.d-none]="isLoading">
        <form class="theme-form" [formGroup]="updateForm" (ngSubmit)="submit($event)">
            <div class="row g-3">
                <!-- Prénom et Nom -->
                <div class="col-md-6">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="prenom" formControlName="prenom" placeholder="Prénom">
                        <label for="prenom">Prénom</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('prenom')?.touched && updateForm.get('prenom')?.errors?.['required']">
                        Veuillez remplir le champ prénom
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="name" formControlName="name" placeholder="Nom">
                        <label for="name">Nom</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('name')?.touched && updateForm.get('name')?.errors?.['required']">
                        Veuillez remplir le champ nom
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="telephone" formControlName="telephone" placeholder="Téléphone">
                        <label for="telephone">Téléphone</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('telephone')?.touched && updateForm.get('telephone')?.errors?.['required']">
                        Veuillez remplir le champ Téléphone
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email">
                        <label for="email">Email</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('email')?.touched && updateForm.get('email')?.errors?.['required']">
                        Veuillez remplir le champ mail
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('email')?.errors?.['email']">
                        L'adresse mail est invalide
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <select class="form-select" id="domain_id" formControlName="domain_id">
                            <option selected>Selection votre domaine</option>
                            <option *ngFor="let option of domains" [value]="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <label for="domain_id">Domaine</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('domain_id')?.touched && updateForm.get('domain_id')?.errors?.['required']">
                        Veuillez remplir le champ domaine
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <select class="form-select" id="category_id" formControlName="category_id">
                            <option selected>Selection votre domaine</option>
                            <option *ngFor="let option of categories" [value]="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <label for="category_id">Catégorie</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('category_id')?.touched && updateForm.get('category_id')?.errors?.['required']">
                        Veuillez remplir le champ catégorie
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <select class="form-select" id="nationalite_id" formControlName="nationalite_id">
                            <option value="">Sélectionnez une nationalité</option>
                            <option *ngFor="let nationality of nationalities" [value]="nationality.id">
                                {{ nationality.name }}
                            </option>
                        </select>
                        <label for="nationalite_id">Nationalité</label>
                    </div>
                    <div class="invalid-feedback" *ngIf="updateForm.get('nationalite_id')?.touched && updateForm.get('nationalite_id')?.errors?.['required']">
                        Veuillez sélectionner une nationalité
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-floating">
                        <input type="password" class="form-control" id="password" formControlName="password" placeholder="Mot de passe">
                        <label for="password">Mot de passe</label>
                    </div>
                </div>
                <!-- Boutons d'action -->
                <div class="col-12 mt-4">
                    <div class="d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-secondary" (click)="modalServices.dismiss()">Annuler</button>
                        <button type="submit" class="btn btn-primary" [disabled]="isLoading || !updateForm.valid">
                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                            Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>